import React from 'react';

interface OrderStepProgressProps {
  currentStep: number;
}

const OrderStepProgress: React.FC<OrderStepProgressProps> = ({ currentStep }) => (
  <div className="step-progress-wrapper d-flex flex-column flex-sm-row justify-content-start justify-content-sm-center align-items-start align-items-sm-center gap-3 gap-sm-4 py-3 px-4 bg-white rounded-4 shadow-sm border border-light mx-auto" style={{ maxWidth: '750px' }}>
    <div className={`step-item d-flex align-items-center gap-2 ${currentStep === 1 ? 'active-step text-primary' : 'text-muted'}`}>
      <span className="step-num-badge">1</span>
      <span className="fw-semibold" style={{ fontSize: '14px' }}>Select Product</span>
    </div>
    <div className="step-connector d-none d-sm-block"></div>
    <div className={`step-item d-flex align-items-center gap-2 ${currentStep === 2 ? 'active-step text-primary' : 'text-muted'}`}>
      <span className="step-num-badge">2</span>
      <span className="fw-semibold" style={{ fontSize: '14px' }}>Specifications</span>
    </div>
    <div className="step-connector d-none d-sm-block"></div>
    <div className={`step-item d-flex align-items-center gap-2 ${currentStep === 3 ? 'active-step text-primary' : 'text-muted'}`}>
      <span className="step-num-badge">3</span>
      <span className="fw-semibold" style={{ fontSize: '14px' }}>Secure Checkout</span>
    </div>
  </div>
);

export default OrderStepProgress;
